import { useTranslation } from "@/hooks/useTranslation";
import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from "@/components/ui/alert-dialog";
import type { OnboardingType } from "@/lib/onboarding/types";

interface TypeChangeConfirmDialogProps {
  open: boolean;
  current: OnboardingType;
  onConfirm: () => void;
  onCancel: () => void;
}

/** §19: changing the type after the day structure is set loses that structure — confirm first. */
export function TypeChangeConfirmDialog({ open, current, onConfirm, onCancel }: TypeChangeConfirmDialogProps) {
  const { t } = useTranslation();
  return (
    <AlertDialog open={open} onOpenChange={(next) => !next && onCancel()}>
      <AlertDialogContent data-testid="onboarding-type-change-dialog">
        <AlertDialogHeader>
          <AlertDialogTitle>{t("onboarding.typeChange.title")}</AlertDialogTitle>
          <AlertDialogDescription>{t("onboarding.typeChange.body")}</AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel onClick={onCancel} data-testid="onboarding-type-change-keep">
            {t("onboarding.typeChange.keep", { type: t(`onboarding.type.${current}`) })}
          </AlertDialogCancel>
          <AlertDialogAction onClick={onConfirm} data-testid="onboarding-type-change-confirm">
            {t("onboarding.typeChange.confirm")}
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
}
